import React from "react";
import LoginContainer from "../components/loginContainer";

const Login = () => {
  return (
    <div className="bg-color">
      <LoginContainer />
    </div>
  );
};

export default Login;
